import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import ProgressLine from './ProgressLine';

export default function ProgressBar(props) {
  const [bar, setBar] = useState([]);
  const [value, setValue] = useState(0);

  useEffect(() => {
    const approvedCount = parseInt(props.approvedCount);
    const rejectCount = parseInt(props.rejectCount);
    const totalRequired = parseInt(props.totalRequired);

    const approvedPercentage = (approvedCount * 100) / totalRequired;
    const rejectedPercentage = (rejectCount * 100) / totalRequired;

    setBar([
      { width: approvedPercentage ? approvedPercentage : 0, color: "var(--brand-secondary)" },
      { width: rejectedPercentage ? rejectedPercentage : 0, color: "red" },
    ]);
    setValue(totalRequired);

  }, [props.approvedCount, props.rejectCount, props.totalRequired]);


  return (
    <Box>
      <div>
        <div>
            <ProgressLine
              label=""
              backgroundColor="lightgrey"
              visualParts={[
                {
                  percentage: `${bar[0]?.width}%`,
                  color: bar[0]?.color,
                },
                {
                  percentage: `${bar[1]?.width}%`,
                  color: bar[1]?.color,
                },
              ]}
            />
          {/* )} */}
        </div>
      </div>
    </Box>
  );
}
